module.exports = __webpack_public_path__ + "img/landscape-2.13dc07ff.png";